import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

/**
 * Bridge for class components that expect Router v4 props (match, location, history).
 * In React Router v6, element={<Component />} does not pass router props.
 * This HOC wraps a class component and provides the expected props.
 */
export function withRouterBridge(Component) {
    return function WithRouterWrapper(props) {
        const params = useParams();
        const location = useLocation();
        const navigate = useNavigate();

        return (
            <Component
                {...props}
                match={{ params }}
                location={location}
                history={{ push: (path, ...rest) => navigate(path, ...rest), replace: (path, ...rest) => navigate(path, ...rest) }}
            />
        );
    };
}
